import {escapeHtml} from './utils/escapeHtml.js';
import {fetchLeadData} from './services/fetch.js';

export function draw_insured_tab(response) {
	clear_insured_tab();

	if(response) {
		$('#modalInsuredSearchForm').data('lead_ims_selected', response.lead_ims_selected);
		$('#modalInsuredSearchForm').data('ims_insured', response.ims_insured);
		$('#modalInsuredSearchForm').data('ims_submissions', response.ims_submissions);
		$('#modalInsuredSearchForm').data('ims_quotes', response.ims_quotes);
		{
			let ims_producers_dirty = response.ims_producers
			let ims_producers = ims_producers_dirty;

			if (!Array.isArray(ims_producers_dirty) && ims_producers_dirty instanceof Object) {
				ims_producers = Object.values(ims_producers_dirty ?? {});
			}
			ims_producers = JSON.parse(JSON.stringify(ims_producers));
			console.log(ims_producers);
			let ims_producer_contacts = JSON.parse(JSON.stringify(response.ims_producer_contacts));

			$.each(ims_producers, function (_i, producer) {
				producer.contacts_data = {};
				$.each(ims_producer_contacts, function (_i, contact) {
					if (producer.ProducerLocationGuid === contact.ParentGUID) {
						if (contact.producerContactGuid) {
							producer.contacts_data[contact.producerContactGuid] = contact;
						}
					}
				});
			});

			$('#modalInsuredSearchForm').data('ims_producers', ims_producers);
		}
		$('#modalInsuredSearchForm').data('agent', response.agent);
		$('#modalInsuredSearchForm').data('ims_submissions_renewal', response.ims_submissions_renewal);
		$('#modalInsuredSearchForm').data('info', response.info);

		$('#insured_name_search_1').val('');
		$('#insured_name_search_1').prop('defaultValue', '');

		// Set the value in the Select2 dropdown
		if ($('#searchInsuredInIMS_1').length) {


			$('#searchInsuredInIMS_1').parents('.btn_wrap').removeClass('loading');
			$('#searchInsuredInIMS_1').parents('.btn_wrap').find('p').hide();


			if (response.lead_ims_selected?.insured_search != null) {
				$('#insured_name_search_1').val(response.lead_ims_selected.insured_search);
				$('#insured_name_search_1').prop('defaultValue', response.lead_ims_selected.insured_search);
			} else if (response.info?.company_name != null) {
				$('#insured_name_search_1').val(response.info.company_name ?? '');
				$('#insured_name_search_1').prop('defaultValue', response.info.company_name ?? '');
			}

		}
	} else {
		$('#modalInsuredSearchForm').data('lead_ims_selected', {});
		$('#modalInsuredSearchForm').data('ims_insured', []);
		$('#modalInsuredSearchForm').data('ims_submissions', []);
		$('#modalInsuredSearchForm').data('ims_quotes', []);
		$('#modalInsuredSearchForm').data('ims_producers', []);
		let agent = $('#modalInsuredSearchForm').data('agent', {});

		$('#insured_name_search_1').val('');
		$('#insured_name_search_1').prop('defaultValue', '');
	}


	draw_insured_table();
	//load cached producers/submissions
	draw_submissions_table();

	draw_quotes_table();

}
// Updated save_insured.js
export function save_insured({is_save_new_email_agency_names = 0} = {}) {
	return new Promise((resolve, reject) => {
		$('.save-area').show();
		$('.save-area button').prop('disabled', true);
		$('.save-area [data-saving_indicator]').show().text('Saving...');

		// Gather the radio control number (if a radio is checked).
		let last_control_number =
			$('#insured .radio_control_number:checked').val() ||
			$('#ims_control_number').val().trim() ||
			'';

		let insured_search_term = $('#insured_name_search_1').prop('defaultValue') || undefined;
		let producer_search_term = $('#producer_name_search_1').prop('defaultValue') || undefined;

		let producer_guid = $('.producer_contact:checked').attr('data-producer_guid') || undefined;
		let producer_location_guid =
			$('.producer_contact:checked').attr('data-producer_location_guid') || undefined;
		let producer_contact_guid = $('.producer_contact:checked').val() || undefined;

		let insured_guid =
			$('#insured_table .insured_radio:checked')
				.parents('[data-type="insured"]')
				.attr('data-item_id') || undefined;
		let insured_location_guid =
			$('#insured_table .insured_radio:checked')
				.parents('[data-type="insured"]')
				.attr('data-insured_location_guid') || undefined;
		let insured_contact_guid =
			$('#insured_table .insured_radio:checked')
				.parents('[data-type="insured"]')
				.attr('data-insured_contact_guid') || undefined;

		let submission_guid =
			$('#insured_table .submission_radio:checked')
				.parents('[data-type="submission"]')
				.attr('data-item_id') || undefined;

		if (submission_guid) {
			producer_guid =
				$('#insured_table .submission_radio:checked')
					.parents('[data-type="submission"]')
					.attr('data-producer_guid') || undefined;
			producer_location_guid =
				$('#insured_table .submission_radio:checked')
					.parents('[data-type="submission"]')
					.attr('data-producer_location_guid') || undefined;
			producer_contact_guid =
				$('#insured_table .submission_radio:checked')
					.parents('[data-type="submission"]')
					.attr('data-producer_contact_guid') || undefined;
		}

		let is_new_producer_contact_form_valid = true;

		let is_new_producer_contact;
		let first_name;
		let last_name;
		let email;

		if ($('.producer_contact:checked').is('[data-new_producer_contact_input]')) {
			producer_contact_guid = undefined;

			let new_producer_contact_form_wrap = $('.producer_contact:checked').parents(
				'.new_producer_contact_form_wrap'
			);
			is_new_producer_contact = 1;

			// Validate first name
			first_name = new_producer_contact_form_wrap.find('[data-field="first_name"]').val();
			{
				let parent_element = new_producer_contact_form_wrap.find('[data-field="first_name"]').parent();
				parent_element.children('.error').remove();
				first_name = String(first_name).trim();
				if (!first_name) {
					is_new_producer_contact_form_valid = false;
					parent_element.append('<span class="error">First Name is required</span>');
				}
			}

			// Validate last name
			last_name = new_producer_contact_form_wrap.find('[data-field="last_name"]').val();
			{
				let parent_element = new_producer_contact_form_wrap.find('[data-field="last_name"]').parent();
				parent_element.children('.error').remove();
				last_name = String(last_name).trim();
				if (!last_name) {
					is_new_producer_contact_form_valid = false;
					parent_element.append('<span class="error">Last Name is required</span>');
				}
			}

			// Validate email
			email = new_producer_contact_form_wrap.find('[data-field="email"]').val();
			{
				let input_element = new_producer_contact_form_wrap.find('[data-field="email"]');
				let parent_element = input_element.parent();
				parent_element.children('.error').remove();
				email = String(email).trim();
				if (!email) {
					is_new_producer_contact_form_valid = false;
					parent_element.append('<span class="error">Email is required</span>');
				} else if (input_element.prop('validity')?.typeMismatch === true) {
					is_new_producer_contact_form_valid = false;
					parent_element.append('<span class="error">Please enter a valid email address</span>');
				}
			}
		}

		if (!is_new_producer_contact_form_valid) {
			$('.save-area button').prop('disabled', false);
			$('.save-area [data-saving_indicator]').hide();
			alert('Error in `Add new Producer Contact` form');
			reject();
			return;
		}

		$.ajax({
			type: 'POST',
			url: '/leads/save_lead_ims_data', // Update to your actual endpoint
			dataType: 'json',
			data: {
				insured_guid,
				insured_location_guid,
				insured_contact_guid,
				submission_guid,
				producer_location_guid,
				producer_guid,
				producer_contact_guid,
				insured_search: insured_search_term,
				producer_search: producer_search_term,
				lead_id: $('#lead_id').val(),
				is_save_new_email_agency_names,

				// data for new producer contact
				is_new_producer_contact,
				first_name,
				last_name,
				email,

				// control number
				last_control_number,
			},
			success: function (response) {
				// Hide "Saving..." message, re-enable buttons, resolve the promise
				$('.save-area [data-saving_indicator]').hide();
				$('.save-area button').prop('disabled', false);
				resolve(response);
			},
			error: function () {
				$('.save-area').hide();
				$('.save-area [data-saving_indicator]').hide();
				$('.save-area button').prop('disabled', false);
				alert('Error saving Insured');
				reject();
			},
		});
	});
}



function draw_insured_table() {
	let insured_list = $('#modalInsuredSearchForm').data('ims_insured') ?? [];
	let {insured_guid: selectedInsuredGuid} = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};
	let lead_ims_selected = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};
	lead_ims_selected.insured_guid = null;
	$('#modalInsuredSearchForm').data('lead_ims_selected', lead_ims_selected);

	$('#searchInsuredInIMS_1').parents('.btn_wrap').removeClass('loading');
	$('#searchInsuredInIMS_1').parents('.btn_wrap').find('p').hide();
	$('#searchInsuredInIMS_1').show();

	// Initialize the table body
	let tbody = $('#insured_table tbody');
	tbody.empty();

	$('#insured_name_search_1').prop('defaultValue') ?? '';

	if (!insured_list || !Array.isArray(insured_list)) {
		console.error('Error: ims_insured is not an array or is missing');
	}

	if (!insured_list || !Array.isArray(insured_list) || insured_list.length === 0) {
		$('.InsuredSearchResult').html('Nothing found in IMS');
		let term = $('#insured_name_search_1').prop('defaultValue') ?? '';
		// Create the table row
		let row = `
                <tr 
                data-item_id="" 
                data-insured_location_guid=""
                data-insured_contact_guid=""
                data-type="insured" data-producer_qty="0" >
                    <td></td>
                    <td class="editable" data-name="insurance_company">${term}</td>
                    <td class="editable" data-state_code="insured_state_code"></td>
                    <td class="editable no-wrap" data-name="policy_number">[New Insured]</td>
                    <td></td>
                </tr>
               <td></td>
                <td colspan="4" class="producer" data-producer-search>
               
				</td>
            `;
		tbody.append(row);
		draw_producers_table($(tbody.find('[data-producer-search]')));
		insured_list = [];
	}

	// Iterate over the insureds and create table rows
	$.each(insured_list, function (index, insuredItem) {

		let checkedAttr = ' ';
		if (selectedInsuredGuid == null) {
			selectedInsuredGuid = insuredItem.InsuredGUID;
		}
		if (selectedInsuredGuid != null && selectedInsuredGuid === insuredItem.InsuredGUID) {
			checkedAttr = 'checked';

			lead_ims_selected.insured_guid = selectedInsuredGuid;
			$('#modalInsuredSearchForm').data('lead_ims_selected', lead_ims_selected);
		}

		let submition_html = '';
		if (insuredItem.NumSubmissions != null) {
			submition_html = `<label class="insured_link link" for="insured_radio_${insuredItem.InsuredGUID}">${insuredItem.NumSubmissions} Submissions</label>`;
		}
		// Create the table row
		let row = `
                <tr 
                data-item_id="${insuredItem.InsuredGUID || ''}"
                data-insured_location_guid="${insuredItem.InsuredLocationGUID || ''}"
                data-insured_contact_guid="${insuredItem.InsuredContactGUID || ''}"
                 data-type="insured" data-producer_qty="${insuredItem.NumSubmissions ?? 0}" >
                    <td>
                    	<input 
                    	class="insured_radio"
                    	type="radio" name="insured_radio" id="insured_radio_${insuredItem.InsuredGUID}" 
						${checkedAttr} >
                    </td>
                    <td class="editable" data-name="insurance_company">${insuredItem.PolicyName}</td>
                    <td class="editable" data-name="insured_state_code">${insuredItem.state_code || ''}</td>
                    <td class="editable no-wrap" data-name="policy_number">${insuredItem.InsuredID ?? '[New Insured]'}</td>
                    <td>${submition_html}</td>
                </tr>
            `;

		// Append the row to the table body
		tbody.append(row);
	});

	// Show the table
	$('#insured_table').show();
}

function draw_submissions_table() {

	let ims_submissions = $('#modalInsuredSearchForm').data('ims_submissions') ?? [];
	let agent = $('#modalInsuredSearchForm').data('agent') ?? {};
	let {
		insured_guid: insuredGuid,
		submission_guid: selectedSubmissionGUID,
		producer_guid: selectedProducerGUID,
	} = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};

	if (insuredGuid == null) return;
	// Find the corresponding insured row
	let row = $(`#insured_table tr[data-type="insured"][data-item_id="${insuredGuid}"]`);

	let quotesLinkElement = row.find('.insured_link');

	let producer_qty = ims_submissions.length;

	if (ims_submissions.length === 0) {
		quotesLinkElement.text('No Quotes Found');
	} else {
		row.data('producer_qty', producer_qty);
		row.find('.insured_link').text(`${producer_qty} Submissions`);
	}


	let existingNestedRows = $('#insured_table').find('.nested_level_1');

	// Remove any previously appended nested rows
	existingNestedRows.remove();


	if (ims_submissions.length === 0) {
		row.after(`<tr class="nested_level_1"><td colspan="5" data-producer-search></td></tr>`);

		draw_producers_table($(row.next('.nested_level_1').find('[data-producer-search]')));

		return;
	}
	// Create a nested table for submissions
	let nestedTable = `
        <table class="nested_table">
            <thead>
                <tr>
                    <th></th> <!-- For the radio buttons -->
                    <th>Submission ID</th>
                    <th>Producer</th>
                    <th>Underwriter</th>
                    <th>Submitted</th>
                    <th>Quotes</th>
                </tr>
            </thead>
            <tbody>
            </tbody>
        </table>`;

	// Append a new row to host the nested table
	row.after(`<tr class="nested_level_1"><td colspan="5">${nestedTable}</td></tr>`);

	// Get the nested table's body
	let nestedTableBody = row.next('.nested_level_1').find('.nested_table tbody');

	let latestSubmission = null;
	let today_date = new Date();
	let today_date_formated = moment(today_date).format('MM/DD/YYYY');
	//add empty submission - when no producer found
	let search_row = `
            <tr data-insured_item_id="${insuredGuid}" data-type="submission">
                <td>
                    <input 
                    class="	submission_radio"
                    type="radio"  name="submission_radio" id="submission_radio_0"
                    value="0"
                    >
                </td>
               
                <td colspan="5" class="producer" data-producer-search>
               
				</td>			
                 
            </tr>
`;
	// Populate the nested table with the submission data (order remains unchanged)
	ims_submissions.forEach(function (submission) {
		// Determine the latest submission
		if (!latestSubmission || new Date(submission['submitted_date']) > new Date(latestSubmission['submitted_date'])) {
			latestSubmission = submission;
		}

		let row = `
            <tr 
            data-item_id="${submission['SubmissionGroupGUID']}" 
            data-producer_contact_guid="${submission.ProducerContactGUID || ''}"
            data-producer_guid="${submission.producer_guid || ''}"
            data-producer_location_guid="${submission.ProducerLocationGUID || ''}"
            data-type="submission" data-quote_qty="${submission['qty_on_quotes']}" 
            >
                <td>
                    <input 
                    class="submission_radio"
                    type="radio"  name="submission_radio" id="submission_radio_${submission['SubmissionGroupGUID']}"
                    >
                </td>
                <td>${submission['SubmissionGroupID']}</td>
                <td class="producer">${submission['producer_name']}
                <br><span>${submission['producer_contact_email']}</span>
                </td>
                <td>${submission['underwriter_name']}</td>
                <td>${submission['submitted_date'] ? moment(submission['submitted_date'], 'YYYY-MM-DD').format('MM/DD/YYYY') : ''}</td>
                <td>
                    <label class="submission_link link" for="submission_radio_${submission['SubmissionGroupGUID']}">${submission['qty_on_quotes']} Quote(s)</label>
                </td>
            </tr>`;
		nestedTableBody.append(row);
	});

	nestedTableBody.append(search_row);


	draw_producers_table($(nestedTableBody.find('[data-producer-search]')));

	// Handle row selection logic
	let selectedSubmission = null;

	if (selectedSubmissionGUID) {
		// Find the row with the selected ProducerGUID
		selectedSubmission = ims_submissions.find(producer => (String(producer['SubmissionGroupGUID'])).toLowerCase() === selectedSubmissionGUID.toLowerCase());
	}
	if (selectedProducerGUID && !selectedProducerGUID) {
		if (!selectedSubmission) {
			// If no selected ProducerGUID is provided or it's not found, use the latest submission
			selectedSubmission = latestSubmission;
		}
	}


	// Select the row and trigger get_quotes for the selected submission
	if (selectedSubmission) {
		let selectedRow = nestedTableBody.find(`tr[data-type="submission"][data-item_id="${selectedSubmission['SubmissionGroupGUID']}"]`);
		selectedRow.find('.submission_radio').prop('checked', true); // Set radio button as selected

		let lead_ims_selected = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};
		lead_ims_selected.submission_guid = selectedSubmission['SubmissionGroupGUID'];
		$('#modalInsuredSearchForm').data('lead_ims_selected', lead_ims_selected);
	}


}

function draw_producers_table($parent_element) {
	let ims_producers = $('#modalInsuredSearchForm').data('ims_producers') ?? [];
	let agent = $('#modalInsuredSearchForm').data('agent') ?? {};

	let {
		producer_contact_guid: selectedProducerContactGUID,
		producer_search,
		submission_guid: selectedSubmissionGUID,
	} = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};



	let producer_ui = '<ul style="padding: 0px; margin: 0px;">';

	let hasSavedProducerContact = false;
	let currentSelectedProducerContactGUID = null;

	if (!selectedSubmissionGUID) {

		$.each(ims_producers, function (key, item) {

			let contacts_data = item.contacts_data;
			$.each(contacts_data, function (cnt_guid, cnt) {
				hasSavedProducerContact ||= selectedProducerContactGUID === cnt_guid;
				if (currentSelectedProducerContactGUID) return;
				if (!agent.email) return;
				if (String(cnt.Email ?? '').toLowerCase().includes(String(agent.email).toLowerCase())) {
					currentSelectedProducerContactGUID = cnt_guid;
				}
			});

		});
		if (selectedProducerContactGUID && hasSavedProducerContact) {
			currentSelectedProducerContactGUID = selectedProducerContactGUID;
		}

	}
	{
		$.each(ims_producers, function (key, item) {

			producer_ui += `<li data-producer_location_guid="${item.ProducerLocationGuid}" style="border-radius: 5px;\n` + '    padding: 20px;\n' + '    list-style: none;\n' + '    border: 1px solid #82c9f3; margin-bottom: 20px;">';
			producer_ui += '<div  > <b>' + item.ProducerName + '</b></div>';
			producer_ui += '<div class="producer_location">';
		//	producer_ui += '<br>' + item.LocationName;
			producer_ui += item.Address1 + '<br> ';
			producer_ui += item.City + ', ' + item.State + ', ' + item.ZipCode;
			producer_ui += '</div>';
			producer_ui += '<div class="producer_search_result_label_wrap" style="display: flex; flex-wrap: wrap;\n' + '    justify-content: left;">';

			//	insured += '<br>  ' + item.InsuredGuid;
			let contacts_data = item.contacts_data;
			$.each(contacts_data, function (cnt_guid, cnt) {
				let selectedRadio = '';
				producer_ui += '<label class="producer_search_result_label" style="  " for="' + cnt_guid + '">';
				producer_ui += '<div class="input_wrap">';
				producer_ui += '<input ' + selectedRadio + ' class="producer_contact" type="radio" name="producer_search_result" value="' + cnt_guid + '" id="' + cnt_guid + '"  ' +
					' data-producer_contact_guid="' + cnt_guid + '"' +
					' data-producer_guid="' + item.ProducerGUID + '"' +
					' data-producer_location_guid="' + item.ProducerLocationGuid + '"' +
					' />';
				producer_ui += '<input  type="hidden"   value=\'' + escapeHtml(JSON.stringify(item)) + '\' id="item_' + cnt_guid + '"  />';
				producer_ui += '</div>';
				producer_ui += '<div class="text_part">';
				producer_ui += '<div  class="FName" > <b>' + escapeHtml(cnt.FName) + '</b> </div>';
				producer_ui += '<div  class="LName" > <b>' + escapeHtml(cnt.LName) + '</b> </div>';
				producer_ui += ' <div class="Email" >  ' + escapeHtml(cnt.Email) + '</div>';
				producer_ui += ' <div>  ' + escapeHtml(cnt.Phone) + '</div>';
				producer_ui += '</div>';
				producer_ui +=   '</label>';
			});

			producer_ui += `<div class="new_producer_contact_form_wrap" style="">
				<label style="display: flex; padding: 10px;">
				<input class="producer_contact" data-new_producer_contact_input type="radio" name="producer_search_result" value="" style="width: auto; margin-left: 10px; margin-right: 10px;" 
									 data-producer_contact_guid
					 data-producer_guid="${item.ProducerGUID}"
					 data-producer_location_guid="${item.ProducerLocationGuid}"
				/> Add new Producer Contact</label>
				<form class="new_producer_contact_form" style="display: none; padding: 10px;" >
					<div class="company_name_label">
						Company Name
						<input type="hidden" class="value company_name" data-field="company_name" data-title="Company Name" placeholder="Company Name" readonly value="${escapeHtml(item.ProducerName)}">
						<input class="value company_name" data-field="company_name" data-title="Company Name" placeholder="Company Name" readonly value="${escapeHtml(item.ProducerName)}">
					</div>
					<div class="Full_name_label">
						<div class="first_name_label">
							<span>First Name</span>
							<input type="text" class="value first_name" data-field="first_name" data-title="First Name" placeholder="First Name" value="${escapeHtml(agent.first_name)}" required>
						</div>
						<div class="last_name_label">
							<span>Last Name</span>
							<input type="text" class="value last_name" data-field="last_name" data-title="Last Name" placeholder="Last Name" value="${escapeHtml(agent.last_name)}" required>
						</div>
					</div>
					<div class="Full_name_label">
					<div class="email_label">
						Email
						<input type="email" class="value email" data-field="email" data-title="Email" placeholder="Email" value="${escapeHtml(agent.email)}" required>
					</div>
					</div>
				</form>
</div>`;

			producer_ui += '</li>';

		});
	}
	producer_ui += '</ul>';


	let search_row = `
				<div class="search_wrap producer_search_title">Search & Select Another Producer in IMS:</div>
                <div class="search_wrap producer_search_wrap">
                
					   <input autocomplete="off" type="text" class="form-control producer_name_search_1 " id="producer_name_search_1" placeholder="Producer Name" name="producer_name_search" value="">
						<div class="btn_wrap">
							<p style="display: none;">Searching...</p>
							<button   id="searchProducerInIMS_1" type="button" class="searchProducerInIMS_1 btn btn-success waves-effect waves-light">Search</button>
						</div>
				</div>
				
				<div class="form-group row producerSearchResultWrap " style="  border-top: 1px solid rgb(233, 236, 239); margin-top: 20px;">

					<div class="col-sm-12 producerSearchResult" style="padding: 7px 0;">
						${producer_ui}
					</div>
					Please don't forget to click 'Save' if you want to apply changes.
				
					</div>`;

	$parent_element.empty().append(search_row);

	if(!selectedSubmissionGUID) {
		$parent_element.find(`[data-producer_contact_guid]`).not('[data-new_producer_contact_input]').first().prop('checked', true);
		if (currentSelectedProducerContactGUID) {
			console.log(currentSelectedProducerContactGUID);
			$parent_element.find(`[data-producer_contact_guid="${currentSelectedProducerContactGUID}"]`).prop('checked', true);
		}

		$parent_element.parents(`[data-insured_item_id][data-type="submission"]`).first().find('.submission_radio').prop('checked', true);
	}

	let agency = producer_search ?? agent.company_name ?? '';
	$parent_element.find('#producer_name_search_1').val(agency);
	$parent_element.find('#producer_name_search_1').prop('defaultValue', agency);
}
function isEmptyObject(obj) {
	return (
		!!obj &&
		obj.constructor === Object &&
		Object.keys(obj).length === 0
	);
}

function draw_quotes_table() {
	let info = $('#modalInsuredSearchForm').data('info') ?? [];
	let ims_quotes = $('#modalInsuredSearchForm').data('ims_quotes') ?? [];
	let ims_submissions_renewal = $('#modalInsuredSearchForm').data('ims_submissions_renewal') ?? {};
	console.error('ims_submissions_renewal', ims_submissions_renewal);
	console.log( isEmptyObject(ims_submissions_renewal));
	let {
		submission_guid: submissionGroupGUID,
		last_control_number: last_control_number
	} = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};

	if (!submissionGroupGUID) return;
	let row = $(`#insured_table tr[data-type="submission"][data-item_id="${submissionGroupGUID}"]`);



	let quotesLinkElement = row.find('.submission_link');

	if (!ims_quotes || ims_quotes.length === 0) {
		quotesLinkElement.text('No Quotes Found');
		return;
	}

	let quote_qty = ims_quotes.length;
	row.data('quote_qty', quote_qty);
	quotesLinkElement.text(`${quote_qty} Quotes`);


	let existingNestedRows = $('#insured_table').find('.nested_level_2');
	existingNestedRows.remove();


	// Determine the class for the quotes container
	let containerClass = 'new'; // Default to "new"
	let suggestedStatus = 'New'; // Default suggested status
	if (info.business_type_id == 2) {
		containerClass = 'renewal';
		suggestedStatus = 'Renewal';
	} else if (info.business_type_id == 3) {
		containerClass = 'decline';
		suggestedStatus = 'Decline';
	} else if (info.business_type_id == 4) {
		containerClass = 'decline';
		suggestedStatus = 'Decline / Duplicate';
	}

	// Create quotes container with determined class
	let quotesContainer = `
                <div class="quotes_container ${containerClass}">
                    <div class="quotes_column">
                        <ul class="quote_list"></ul>
                    </div>
                </div>`;

	// Append a new row for quotes
	row.after(`<tr class="nested_level_2"><td colspan="8">${quotesContainer}</td></tr>`);

	let quote_list = row.next('.nested_level_2').find('.quote_list');
	// Populate quotes
	// <strong>QuoteStatusID:</strong> <span class="highlight">${quote.QuoteStatusID || 'N/A'}</span><br>
	// 	<strong>Bound:</strong> <span class="highlight">${quote.Description || 'N/A'}</span><br>
	ims_quotes.forEach(function (quote) {

		console.log(quote);
		console.log(last_control_number);

		const effectiveDate = quote.EffectiveDate ? moment(quote.EffectiveDate, 'YYYY-MM-DD').format('MM/DD/YYYY') : 'N/A';

		const expirationDate = quote.ExpirationDate ? moment(quote.ExpirationDate, 'YYYY-MM-DD').format('MM/DD/YYYY') : 'N/A';

		let quoteSelected = '';
		if(quote.ControlNo && (last_control_number == quote.ControlNo)) {
			quoteSelected = 'checked="checked"';
		}
		let quoteHtml = `
                    <li class="quote_item">
                     <h5>Quote Details</h5> 
                      <hr style="margin-top: 5px; background-color: transparent; border: 1px solid #e4e4e4;  height: 1px;" />
                      
                    	<div class="quote_row"><strong>Status:</strong> ${quote.DisplayStatus || 'N/A'}</div>
                        <div class="quote_row"><strong>Insured:</strong> ${quote.InsuredPolicyName || 'N/A'}</div>
                        <div class="quote_row"><strong>Control #:</strong> 	
                        <label class="radio_control_number_wrap">
                        	<input type="radio" ${quoteSelected} class="radio_control_number"  name="radio_control_number" value="${quote.ControlNo||0}"> ${quote.ControlNo }</label>
                        </div>
                        <div class="quote_row"><strong>Policy #:</strong> ${quote.PolicyNumber || 'N/A'}</div>
                        <div class="quote_row"><strong>LOB:</strong> ${'Auto Liability'}</div>
                       <div class="quote_row"> <strong>Effective:</strong> ${effectiveDate}</div>
                       <div class="quote_row"> <strong>Expires:</strong> ${expirationDate}</div>
                        
                    </li>`;
		quote_list.append(quoteHtml);
	});


	// Add current submission/quote details with suggested status
	let currentQuoteHtml = `
                <li class="quote_item current_quote">     
                    <h5>Suggested Status:</h5> 
                    <span class="highlight bold">${suggestedStatus}</span><br>`;
	// Safeguard ims_submissions_renewal
	if (!isEmptyObject(ims_submissions_renewal)) {

		const effectiveDateR = ims_submissions_renewal.EffectiveDate ? moment(ims_submissions_renewal.EffectiveDate, 'YYYY-MM-DD').format('MM/DD/YYYY') : 'N/A';

		const expirationDateR = ims_submissions_renewal.ExpirationDate ? moment(ims_submissions_renewal.ExpirationDate, 'YYYY-MM-DD').format('MM/DD/YYYY') : 'N/A';


		currentQuoteHtml += `        <hr style="margin-top: 5px; background-color: transparent; border: 1px solid #e4e4e4;  height: 1px;" />
                     <strong>Status:</strong> ${ims_submissions_renewal.DisplayStatus || 'N/A'}<br>
                    <strong>Insured:</strong> ${ims_submissions_renewal.InsuredPolicyName || 'N/A'}<br>
                    <strong>Control #:</strong> ${ims_submissions_renewal.ControlNo || 'N/A'}<br>
                    <strong>Policy #:</strong> ${ims_submissions_renewal.PolicyNumber || 'N/A'}<br>
                    <strong>LOB:</strong> ${'Auto Liability'}<br>
                    <strong>Effective:</strong> ${effectiveDateR}<br>
                    <strong>Expires:</strong> ${expirationDateR}<br>`;
	}
	currentQuoteHtml += `</li>`;

	quote_list.append(currentQuoteHtml);


}





$('#insured').on('click', '.searchInsuredInIMS_1', function (e) {

	e.preventDefault();
	$('#insured_table').hide();
	$('.save-area').hide();
	$(this).hide();

	let insured = $('#insured_name_search_1').val();
	$('#insured_name_search_1').prop('defaultValue', insured);

	// Show loading GIF
	$(this).parents('.btn_wrap').addClass('loading');
	$(this).parents('.btn_wrap').find('p').show();

	$('#modalInsuredSearchForm').data('ims_insured', []);

	let lead_ims_selected = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};
	lead_ims_selected.insured_guid = null;
	$('#modalInsuredSearchForm').data('lead_ims_selected', lead_ims_selected);

	$.ajax({
		type: 'POST', url: '/leads/search_insured',

		dataType: 'json', data: {
			'term': insured, lead_id: $('#lead_id').val(),
		}, cache: false,

		success: function (response) {

			$('#modalInsuredSearchForm').data('ims_insured', response.ims_insured);
			draw_insured_table();

			$('.save-area').show();

			getSubmissionsForInsured();
		}, error: function (response) {
			$('.InsuredSearchResult').html('Nothing found in IMS');
		},
	});
});

$('#insured').on('click', '.searchProducerInIMS_1', function (e) {
	e.preventDefault();
	$('.save-area').show();

	let producer = $('#producer_name_search_1').val();

	$('#submission_radio_0').trigger('click');
	// Show loading spinner if needed
	let this_ref = this;
	$(this_ref).hide();
	$('.nested_level_2').hide();

	let term = $('#producer_name_search_1').val();
	$('#producer_name_search_1').prop('defaultValue', term);


	let lead_ims_selected = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};
	lead_ims_selected.producer_search = term;
	$('#modalInsuredSearchForm').data('lead_ims_selected', lead_ims_selected);
	// Show loading GIF
	$(this_ref).parents('.btn_wrap').addClass('loading');
	$(this_ref).parents('.btn_wrap').find('p').show();


	$.ajax({
		type: 'POST', url: '/ims_twentymiles/producerSearch',

		dataType: 'json', data: {
			'producer': producer,
		}, //contentType: false,
		cache: false, //processData:false,

		//	(MVR Vio: 11/25/2022 - UNSAFE SPD FOR ·Condition's ), (LR Accident: 10/15/2022)
		success: function (response) {
			let ims_producers = response;

			if (!Array.isArray(ims_producers) && ims_producers instanceof Object) {
				ims_producers = Object.values(ims_producers ?? {});
			}

			if (!Array.isArray(ims_producers) || ims_producers.length === 0) {


				$('.producerSearchResult').html('Nothing found in IMS');
				$('.producerSearchResultWrap').show();
				$('#searchProducerInIMS_1').show();
				$('.loading_producer_search').hide();
				$(this_ref).parents('.btn_wrap').removeClass('loading');
				$(this_ref).parents('.btn_wrap').find('p').hide();
				$(this_ref).show();
			} else {

				$('#modalInsuredSearchForm').data('ims_producers', ims_producers);
				draw_producers_table($(this_ref).parents('[data-producer-search]'));

			}

			$('.save-area').show();

		}, error: function (response) {
			$('.producerSearchResult').html('Search Error');
			$('.producerSearchResultWrap').show();
			$('.loading_producer_search').hide();
			$(this_ref).parents('.btn_wrap').removeClass('loading');
			$(this_ref).parents('.btn_wrap').find('p').hide();
			$(this_ref).show();
		},

	});
});


// Event handler for change on radio buttons
$('#insured').on('change', 'input.insured_radio[type="radio"]', function (e) {
	$('.save-area').show();

	let row = $(this).parents('[data-type="insured"]');

	let insuredGuid = row.data('item_id');

	let lead_ims_selected = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};
	lead_ims_selected.insured_guid = insuredGuid;
	$('#modalInsuredSearchForm').data('lead_ims_selected', lead_ims_selected);
	// Call function to get submissions for the selected insured
	getSubmissionsForInsured();

});

$('#insured').on('change', 'input.producer_contact[type="radio"]', function (e) {
	{
		let currentWrapper = $(this).parents('.new_producer_contact_form_wrap').find('.new_producer_contact_form');
		$('#insured').find('.new_producer_contact_form').not(currentWrapper).slideUp();
		if ($(this).is('[data-new_producer_contact_input]')) {
			$(this).parents('.new_producer_contact_form_wrap').find('.new_producer_contact_form').slideDown();
		}
	}
	$(this).parents('[data-type="submission"]').find('input.submission_radio[type="radio"]').prop('checked', true);
	$('.save-area').show();
});

$('#insured').on('input', '#insured_name_search_1', function (e) {
	$('#insured_table').hide();
	$('.save-area').hide();
});


$('#insured').on('input', '#producer_name_search_1', function (e) {
	$('.producerSearchResultWrap').hide();
	$('.save-area').hide();
});

$('#insured').on('change', 'input.submission_radio[type="radio"]', function (e) {
	$('.save-area').show();
	//uncheck any control number
	$('#insured .radio_control_number[type="radio"]').prop('checked', false);


	if ($(this).is('#submission_radio_0')) {
		return;
	}

	$('#insured .producer_contact:checked').prop('checked', false);

	let row = $(this).parents('[data-type="submission"]');

	// Get the Submission GUID and Insured ID
	let submissionGroupGUID = row.data('item_id');


	let lead_ims_selected = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};
	lead_ims_selected.submission_guid = submissionGroupGUID;
	$('#modalInsuredSearchForm').data('lead_ims_selected', lead_ims_selected);

	// Call the get_quotes() function
	get_quotes();
});



$('#insured #revertInsuredMatch').on('click', function (e) {
	cancel_insured_edit();
});

function getSubmissionsForInsured() {
	let {insured_guid: selectedInsuredGuid} = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};

	let row = $(`#insured_table tr[data-type="insured"][data-item_id="${selectedInsuredGuid}"]`);

	let producer_qty = row.data('producer_qty');

	// Show loading spinner if needed
	row.find('.insured_link').text('Loading...');

	$('#modalInsuredSearchForm').data('ims_submissions', []);

	if (selectedInsuredGuid) {
		$.ajax({
			type: 'POST', url: '/leads/get_submissions', // replace with your actual URL
			dataType: 'json', data: {
				'insuredGuid': selectedInsuredGuid, 'lead_id': $('#lead_id').val(),
			}, success: function (response) {

				$('#modalInsuredSearchForm').data('ims_submissions', response.ims_submissions);

				draw_submissions_table();

				$('.save-area').show();

				get_quotes();
			}, error: function () {
				// Handle error
				row.find('.insured_link').text(`${producer_qty} Submissions`);
				alert('Error fetching submissions');
			},
		});
	}

}

function get_quotes() {
	let {submission_guid: submissionGroupGUID} = $('#modalInsuredSearchForm').data('lead_ims_selected') ?? {};

	let row = $(`#insured_table tr[data-type="submission"][data-item_id="${submissionGroupGUID}"]`);

	let quote_qty = row.data('quote_qty');

	// Show loading indicator
	row.find('.submission_link').text('Loading...');

	$.ajax({
		type: 'POST', url: '/leads/get_quotes', // Update this to your actual endpoint
		dataType: 'json', data: {
			'submissionGroupGUID': submissionGroupGUID, 'lead_id': $('#lead_id').val(),
		}, success: function (response) {
			$('#modalInsuredSearchForm').data('info', response.info);
			$('#modalInsuredSearchForm').data('ims_quotes', response.quotes);
			$('#modalInsuredSearchForm').data('ims_submissions_renewal', response.ims_submissions_renewal);
			draw_quotes_table();

		}, error: function () {
			row.find('.submission_link').text(`${quote_qty} Quotes`);
			alert('Error loading quotes');
		},
	});
}

function clear_insured_tab() {
	$('.save-area').hide();
	$('#insured_table').hide();
	$('#insured_table tbody').empty();
	$('#insured [data-producer-search]').empty();
}
function cancel_insured_edit() {
	clear_insured_tab();

	fetchLeadData($('#lead_id').val()).then((response) => {
		draw_insured_tab(response.lead_data);
	});
}
